import React from 'react';
import Icon from '../../../components/AppIcon';

const DepartmentAvailability = ({ departments }) => {
  // Mock availability data
  const availabilityData = [
    { department: 'hr', available: 8, total: 10, level: 'high' },
    { department: 'finance', available: 6, total: 12, level: 'medium' },
    { department: 'operations', available: 12, total: 20, level: 'medium' },
    { department: 'it', available: 3, total: 8, level: 'low' },
    { department: 'sales', available: 14, total: 15, level: 'high' }
  ];

  const getAvailabilityColor = (level) => {
    const colors = {
      high: 'text-success',
      medium: 'text-warning',
      low: 'text-error'
    };
    return colors?.[level] || 'text-muted-foreground';
  };

  const getAvailabilityBg = (level) => {
    const colors = {
      high: 'bg-success/10',
      medium: 'bg-warning/10',
      low: 'bg-error/10'
    };
    return colors?.[level] || 'bg-muted';
  };

  const getAvailabilityIcon = (level) => {
    const icons = {
      high: 'CheckCircle',
      medium: 'AlertCircle',
      low: 'XCircle'
    };
    return icons?.[level] || 'Circle';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Users" size={20} color="var(--color-primary)" />
        <h3 className="font-heading font-semibold text-foreground">Department Availability</h3>
      </div>
      <div className="space-y-3">
        {availabilityData?.map((dept) => {
          const deptInfo = departments?.find(d => d?.value === dept?.department);
          const percentage = Math.round((dept?.available / dept?.total) * 100);

          return (
            <div key={dept?.department} className={`p-3 rounded-lg ${getAvailabilityBg(dept?.level)}`}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-foreground">
                  {deptInfo?.label || dept?.department}
                </span>
                <Icon 
                  name={getAvailabilityIcon(dept?.level)} 
                  size={16} 
                  className={getAvailabilityColor(dept?.level)}
                />
              </div>
              <div className="flex items-center justify-between text-xs mb-2">
                <span className="text-muted-foreground">
                  {dept?.available} / {dept?.total} available
                </span>
                <span className={`font-medium ${getAvailabilityColor(dept?.level)}`}>
                  {percentage}%
                </span>
              </div>
              {/* Progress bar */}
              <div className="w-full bg-muted rounded-full h-2">
                <div
                  className={`h-2 rounded-full transition-all ${
                    dept?.level === 'high' ? 'bg-success' :
                    dept?.level === 'medium' ? 'bg-warning' : 'bg-error'
                  }`}
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-4 p-3 bg-muted rounded-md">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={14} color="var(--color-primary)" className="mt-0.5" />
          <p className="text-xs text-muted-foreground">
            Availability levels update in real-time based on approved leave and team capacity
          </p>
        </div>
      </div>
    </div>
  );
};

export default DepartmentAvailability;